import React from 'react';
import { Link } from 'react-router-dom';
import { FileDown } from 'lucide-react';
import usePageTitle from '@/hooks/usePageTitle';
import { CATALOGUES } from '@/data/catalogues';

export default function Catalogues() {
  usePageTitle(
    'Catalogues PDF Slot.it & Policar',
    "Téléchargez les catalogues PDF officiels Slot.it et Policar : pièces détachées, accessoires et circuits à l'échelle 1/32."
  );

  return (
    <div className="max-w-screen-xl mx-auto px-4 py-10">
      <nav className="text-xs text-gray-400 mb-6 flex items-center gap-1">
        <Link to="/" className="hover:text-cs-blue transition-colors">Accueil</Link>
        <span>/</span>
        <Link to="/blog" className="hover:text-cs-blue transition-colors">Blog</Link>
        <span>/</span>
        <span className="text-gray-600">Catalogues</span>
      </nav>

      <div className="mb-8">
        <h1 className="font-display font-bold text-3xl text-gray-900 mb-2">CATALOGUES PDF</h1>
        <p className="text-gray-500 max-w-3xl">
          Tous les catalogues officiels Slot.it et Policar, à télécharger gratuitement : pièces détachées,
          accessoires, voitures et circuits à l'échelle 1/32.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-5">
        {CATALOGUES.map((c) => (
          <div
            key={c.id}
            className="flex flex-col bg-white border border-gray-200 rounded-xl p-5 hover:border-cs-blue/40 hover:shadow-sm transition-all"
          >
            <div className="flex items-center gap-2 mb-3">
              <span className="bg-cs-blue text-white text-[11px] font-bold uppercase tracking-wide px-2 py-1 rounded">
                {c.brand}
              </span>
              <span className="text-xs text-gray-400 font-medium">{c.year}</span>
            </div>

            <h2 className="font-display font-bold text-lg text-gray-900 leading-tight mb-2">{c.title}</h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-5 flex-1">{c.description}</p>

            <a
              href={c.pdf_url}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-cs-blue text-white font-bold text-sm px-4 py-2.5 rounded hover:bg-cs-blue-dark transition-colors"
            >
              <FileDown className="w-4 h-4" />
              Télécharger le PDF
              <span className="font-normal opacity-80">({c.size})</span>
            </a>
          </div>
        ))}
      </div>

      <p className="text-xs text-gray-400 mt-8">
        Catalogues édités par le fabricant et publiés ici pour consultation. Les références disponibles
        dans notre boutique se trouvent dans le <Link to="/shop" className="text-cs-blue hover:underline">catalogue en ligne</Link>.
      </p>
    </div>
  );
}